module.exports = __webpack_public_path__ + "shop.svg?75df2b30a329170d4bda5b166056a192";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/shop.svg
// module id = 112
// module chunks = 0